'use strict';
import {AnalyticsEventType} from "./AnalyticsEventType"

/**
 * technique lets us gather all analytics errors up for 50ms, so that if multiple form fields
 * fire events on submission, we only do one analytics change event per AnalyticsEventType
 */

const DEFAULT_ANALYTICS_DEBOUNCE_TIME = 50; //ms

function isValidAnalyticsEventType(e) {
  return e === AnalyticsEventType.ANALYTICS_DATA_UPDATE || e === AnalyticsEventType.DATA_VALIDATION_ERROR;
}

function createEvent(eventType, additionalData) {
  return new CustomEvent(eventType, { detail: additionalData })
}

export function dispatchEvent(eventType, additionalData) {
  //analytic always expect additionalData with action
  additionalData && document.body.dispatchEvent(createEvent(eventType, additionalData));
}

export function AnalyticsEventDispatcher(debounceTimeout = DEFAULT_ANALYTICS_DEBOUNCE_TIME) {
  let dispatchDebouncesByAnalyticsEventType = {};

  function clearTimeoutForEventType(e) {
    if (!dispatchDebouncesByAnalyticsEventType.hasOwnProperty(e)) {
      dispatchDebouncesByAnalyticsEventType.e = null;
    }
    if (dispatchDebouncesByAnalyticsEventType[e] !== null) {
      clearTimeout(dispatchDebouncesByAnalyticsEventType[e]);
      dispatchDebouncesByAnalyticsEventType[e] = null;
    }
  }

  function dispatchAnalyticsEvent(additionalData = null, eventType) {
    if (isValidAnalyticsEventType(eventType)) {
      eventType.forEach((e) => {
        clearTimeoutForEventType(e);
        dispatchDebouncesByAnalyticsEventType[e] = setTimeout(() => dispatchEvent(e, additionalData), debounceTimeout);
      });
    }
  }

  return {dispatchAnalyticsEvent};
}
